import { makeStyles, shorthands } from '@fluentui/react-components';

import circleSolid from '../../media/chart/CircleSolid.svg';
import circleDotted from '../../media/chart/CircleDotted.svg';
import diamondSolid from '../../media/chart/DiamondSolid.svg';
import diamondDotted from '../../media/chart/DiamondDotted.svg';
import triangleDownSolid from '../../media/chart/TriangleDownSolid.svg';
import triangleDownDotted from '../../media/chart/TriangleDownDotted.svg';
import triangleUpSolid from '../../media/chart/TriangleUpSolid.svg';
import triangleUpDotted from '../../media/chart/TriangleUpDotted.svg';

export const useStyles = makeStyles({
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('12px'),

    '& .highcharts-tooltip': {
      '& .highcharts-label-box.highcharts-tooltip-box': {
        opacity: 0,
      },
      '& > span': {
        zIndex: 1,
      },
      '& .perf-graph-tool-tip': {
        display: 'flex',
        boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        '@supports (backdrop-filter: blur(60px))': {
          backdropFilter: 'blur(60px)',
        },
        '& .charts-tooltip': {
          ...shorthands.margin('15px'),

          '& .tool-tip-title': {
            marginBottom: '10px',
          },
          '& .tool-tip-properties': {
            display: 'grid',
            '& .tool-tip-property:nth-child(1)': {
              '-ms-grid-row': '1',
              gridRowStartStart: '1',
              '-ms-grid-column': '1',
              gridColumnStartStart: '1',
              marginRight: '30px',
            },
            '& .tool-tip-property:nth-child(2)': {
              '-ms-grid-row': '1',
              gridRowStart: '1',
              '-ms-grid-column': '2',
              gridColumnStart: '2',
            },
            '& .tool-tip-property:nth-child(3)': {
              '-ms-grid-row': '2',
              gridRowStart: '2',
              '-ms-grid-column': '1',
              gridColumnStart: '1',
              marginRight: '30px',
              marginTop: '10px',
            },
            '& .tool-tip-property:nth-child(4)': {
              '-ms-grid-row': '2',
              gridRowStart: '2',
              '-ms-grid-column': '2',
              gridColumnStart: '2',
              marginTop: '10px',
            },
            '& .tool-tip-property': {
              display: 'flex',

              '& .tool-tip-icon': {
                backgroundRepeat: 'no-repeat',
                width: '14px',
                height: '40px',
                backgroundPositionX: 'center',
                backgroundPositionY: 'center',
                backgroundSize: 'contain',
                marginRight: '15px',
              },
              '& .circle-solid': {
                backgroundImage: `url("${circleSolid}")`,
              },
              '& .circle-shortdash': {
                backgroundImage: `url("${circleDotted}")`,
              },
              '& .diamond-solid': {
                backgroundImage: `url("${diamondSolid}")`,
              },
              '& .diamond-shortdash': {
                backgroundImage: `url("${diamondDotted}")`,
              },
              '& .triangle-down-solid': {
                backgroundImage: `url("${triangleDownSolid}")`,
              },
              '& .triangle-down-shortdash': {
                backgroundImage: `url("${triangleDownDotted}")`,
              },
              '& .triangle-solid': {
                backgroundImage: `url("${triangleUpSolid}")`,
              },
              '& .triangle-shortdash': {
                backgroundImage: `url("${triangleUpDotted}")`,
              },

              '& .tool-tip-details': {

                '& .tool-tip-value': {
                  fontSize: '16px',
                },
              },
            },
          },
        },
      },

      '& .perf-graph-tool-tip.pop': {
        '& .charts-tooltip': {
          ...shorthands.margin('15px'),

          '& .tool-tip-properties': {
            display: 'block',

            '& .tool-tip-property + .tool-tip-property': {
              marginTop: '20px',
            },

            '& .tool-tip-property': {
              display: 'flex',
              marginRight: '0px !important',
            },
          },
        },
      },
    },

    '& .highcharts-xaxis-labels+.highcharts-xaxis-labels': {
      marginTop: '-22px',
    },
  },
  chartContainer: {
    height: '225px',
    fontSize: '12px',
    '& [data-highcharts-chart]': {
      ...shorthands.overflow('visible !important'),
      '& .highcharts-container': {
        ...shorthands.overflow('visible !important'),
        zIndex: 'auto !important', // Fix for the tooltip hidden behind the tile below
        '& .highcharts-root': {
          ...shorthands.overflow('visible'),
        },
      },
    },
  },
  spinner: {
    marginTop: '70px',
  },
});
